export default __webpack_public_path__ + "static/media/11.e2d882a9.png";